import { jsx as _jsx } from "react/jsx-runtime";
import services from 'services';
import OnlineAppointmentConfigForm from 'components/forms/settings/OnlineAppointmentConfigForm';
var PrescriptionsConfigurations = function () {
    var medicalCenterService = services.medicalCenterService;
    var medicalCenter = medicalCenterService.useMedicalCenterInfo().data;
    var _a = medicalCenterService.useEditMedicalCenterConfig(), updateConfig = _a.mutate, isLoading = _a.isLoading;
    if (!medicalCenter)
        return null;
    return (_jsx(OnlineAppointmentConfigForm, { medicalCenter: medicalCenter, updateMedicalCenterConfig: updateConfig, disableReset: isLoading }));
};
export default PrescriptionsConfigurations;
